import { Home, Moon, Sparkles } from "lucide-react";
import type { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import { SoundToggleButton } from "./GameUi";
import { VillageBackdrop } from "./VillageBackdrop";
import { useVisualEffects } from "../hooks/VisualEffectsContext";

interface ShellProps {
  children: ReactNode;
  soundEnabled: boolean;
  onToggleSound: () => void;
}

export function Shell({ children, soundEnabled, onToggleSound }: ShellProps) {
  const home = useLocation().pathname === "/";
  const effects = useVisualEffects();
  return (
    <div className={`app-shell ${home ? "app-shell-home" : "app-shell-room"}`}>
      <VillageBackdrop quiet={!home} />
      <header className="app-utility-bar">
        <Link to="/" className={home ? "app-brand" : "app-home-button"} aria-label="Về trang chủ" title="Về trang chủ">
          {home ? <><Moon aria-hidden="true" /><span>Ma Sói · Đêm Trăng Máu</span></> : <Home aria-hidden="true" />}
        </Link>
        <div className="app-preferences">
          <SoundToggleButton enabled={soundEnabled} onToggle={onToggleSound} />
          <button type="button" className="effects-toggle" onClick={effects.toggle} aria-pressed={effects.reduced} aria-disabled={effects.systemReduced} aria-label={effects.systemReduced ? "Giảm hiệu ứng theo cài đặt hệ điều hành" : "Giảm hiệu ứng"} title={effects.systemReduced ? "Đang ưu tiên giảm chuyển động của hệ điều hành" : "Thay đổi mức hiệu ứng hình ảnh"}>
            <Sparkles aria-hidden="true" /><span>Hiệu ứng: {effects.reduced ? "Giảm" : "Đầy đủ"}</span>
          </button>
        </div>
      </header>
      <div className="app-content">{children}</div>
    </div>
  );
}
